<template>
    <b-form inline class="addNewDetail">

        <RemoteSelect class="main" ref="remoteSelect" v-model="toEmit.productoSeleccionado" remote="ui/presentacionsoverview" allow-grouping data-group="categoria" data-value="presentacion_id_pk_tipo" data-text="titulo_extendido" allow-filter :multiline="2" @changed="changedProducto" placeholder="Busca un ingrediente o artículo"/>

        <b-input-group prepend="Cant:"  class="cant"> <b-form-input  v-model="toEmit.cantidad" type="number"></b-form-input> </b-input-group>

        <b-input-group prepend="$"  class="precio"> 
            <b-form-input :value="subTotal" readonly /> 
        </b-input-group>

        <b-button variant="primary" class="second" @click="agregarProducto" :disabled="!toEmit.productoSeleccionado"> <i class="fa fa-plus"></i> </b-button>

    </b-form>
</template>

<script>
import RemoteSelect from '@/views/elements/remote-select.vue'

import {createNewListDetail} from '../archetype';

export default {
    components: { RemoteSelect },
    name: 'addNewDetail',
    data:() => {
        return {
            toEmit: {
                productoSeleccionado: null,
                cantidad: 1,
                subtotal: 0.0,
            },
            selectedObj: {
                precio: 0
            }
        }
    },
    computed: {
        subTotal(){
            return (this.toEmit.cantidad * this.selectedObj.precio).toFixed(2)
        }
    },
    methods: {
        changedProducto(selected, prod){
            if(selected){
                this.selectedObj = prod;
            } else {
                this.selectedObj.precio = 0
            }
        },
        agregarProducto(){
            this.$emit('addingItem', createNewListDetail({cantidad: this.toEmit.cantidad, obj: this.selectedObj}))
            this.toEmit.productoSeleccionado = null;
            this.toEmit.cantidad = 1;
            this.selectedObj = {
                precio: 0
            }
        }
    }
}

</script>

<style lang="less">
.addNewDetail {
    padding-bottom: 1em;
    border-bottom: 1px solid var(--light);
    .main {
        input {
            width: 25em;
        }
    }
    .cant {
        margin: 0 1em;
        input {
            width: 6em;
        }
    }
    .precio {
        margin-right: 1em;
        input {
            width: 7em;
        }
    }
}
</style>